import { apiDelete, apiGet, apiGetText, apiPost, apiPut } from '../services/apiClient';

const buildQuery = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    search.set(key, value);
  });
  const text = search.toString();
  return text ? `?${text}` : '';
};

const BASE = '/api/admin/email';

export const getEmailDashboard = () => apiGet(`${BASE}/dashboard`);
export const getEmailReportsSummary = () => apiGet(`${BASE}/reports/summary`);
export const getEmailCampaignReport = (id) => apiGet(`${BASE}/reports/campaign/${id}`);

export const listEmailLogs = (params = {}) => apiGet(`${BASE}/logs${buildQuery(params)}`);
export const getEmailLog = (id) => apiGet(`${BASE}/logs/${id}`);
export const retryEmailLog = (id) => apiPost(`${BASE}/logs/${id}/retry`, {});
export const exportEmailLogs = (params = {}) => apiGetText(`${BASE}/logs/export${buildQuery(params)}`);

export const listEmailCampaigns = (params = {}) => apiGet(`${BASE}/campaigns${buildQuery(params)}`);
export const getEmailCampaign = (id) => apiGet(`${BASE}/campaigns/${id}`);
export const createEmailCampaign = (payload) => apiPost(`${BASE}/campaigns`, payload);
export const updateEmailCampaign = (id, payload) => apiPut(`${BASE}/campaigns/${id}`, payload);
export const scheduleEmailCampaign = (id, payload) => apiPost(`${BASE}/campaigns/${id}/schedule`, payload);
export const sendEmailCampaign = (id) => apiPost(`${BASE}/campaigns/${id}/send`, {});
export const pauseEmailCampaign = (id) => apiPost(`${BASE}/campaigns/${id}/pause`, {});
export const cancelEmailCampaign = (id) => apiPost(`${BASE}/campaigns/${id}/cancel`, {});
export const exportEmailCampaigns = () => apiGetText(`${BASE}/campaigns/export`);

export const listEmailTemplates = () => apiGet(`${BASE}/templates`);
export const getEmailTemplate = (id) => apiGet(`${BASE}/templates/${id}`);
export const createEmailTemplate = (payload) => apiPost(`${BASE}/templates`, payload);
export const updateEmailTemplate = (id, payload) => apiPut(`${BASE}/templates/${id}`, payload);
export const deleteEmailTemplate = (id) => apiDelete(`${BASE}/templates/${id}`);
export const previewEmailTemplate = (payload) => apiPost(`${BASE}/templates/preview`, payload);

export const previewEmailAudience = (payload) => apiPost(`${BASE}/audience/preview`, payload);
export const resolveEmailAudience = (payload) => apiPost(`${BASE}/audience/resolve`, payload);

export const getEmailQueue = () => apiGet(`${BASE}/queue`);
export const retryFailedEmailQueue = () => apiPost(`${BASE}/queue/retry-failed`, {});
export const retrySelectedEmailQueue = (payload) => apiPost(`${BASE}/queue/retry-selected`, payload);

export const getEmailSettingsStatus = () => apiGet(`${BASE}/settings/status`);
export const sendEmailTest = (payload) => apiPost(`${BASE}/test-send`, payload);
